import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import Colours from '@shared/ui/atoms/Colours';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import TextField from '@shared/ui/atoms/TextField';
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  KeyResponsibilitiesConfigKey,
  selectFireWardensConfig,
  selectFirstAidersConfig, selectIsLoading,
  selectSelectedOffice,
  updateConfig
} from "../key-responsibilities.duck";
import { tablet } from '@shared/ui/atoms/MediaQueries';

export function KeyResponsibilitiesConfig(props: Props) {
  const [fireWardenValue, setFireWardenValue] = useState(0);
  const [firstAiderValue, setFirstAiderValue] = useState(0);
  const dispatch = useDispatch();
  const selectedOffice = useSelector(selectSelectedOffice);
  const isLoading = useSelector(selectIsLoading);
  const firstAiderConfig = useSelector(selectFirstAidersConfig);
  const fireWardenConfig = useSelector(selectFireWardensConfig);
  const {t} = useTranslation();

  useEffect(() => {
    setFireWardenValue(fireWardenConfig.perUsers as number);
  }, [fireWardenConfig]);

  useEffect(() => {
    setFirstAiderValue(firstAiderConfig.perUsers as number);
  }, [firstAiderConfig]);

  const isDisabled = useMemo(() => isLoading || !selectedOffice, [isLoading, selectedOffice]);

  const onSaveFireWarden = () => {
    dispatch(updateConfig({
      officeId: selectedOffice?.id,
      configId: KeyResponsibilitiesConfigKey.FIRE_WARDEN_PER_STAFF,
      value: `${fireWardenValue}`,
    }));
  }

  const onFireWardenChange = (val: string) => {
    try {
      setFireWardenValue(parseInt(val));
    } catch (e) {
      console.log(e)
      setFireWardenValue(fireWardenValue);
    }
  }

  const onSaveFirstAider = () => {
    dispatch(updateConfig({
      officeId: selectedOffice?.id,
      configId: KeyResponsibilitiesConfigKey.FIRST_AIDER_PER_STAFF,
      value: `${firstAiderValue}`,
    }))
  }

  const onFirstAiderChange = (val: string) => {
    try {
      setFirstAiderValue(parseInt(val));
    } catch (e) {
      console.log(e)
      setFirstAiderValue(firstAiderValue);
    }
  }

  return (
    <Container>
      <ContentCard>
        <HeadlineSmall color={Colours.darkGrey}>{t('reports-page.key-responsib.fire-warden')}</HeadlineSmall>
        <TextField onChange={onFireWardenChange}
                   value={`${fireWardenValue}`}
                   disabled={isDisabled}
                   leftText={'reports-page.key-responsib.one-fire-warden'}
                   onBlur={onSaveFireWarden}
                   rightText={'reports-page.key-responsib.staff'} />
      </ContentCard>

      <ContentCard>
        <HeadlineSmall color={Colours.darkGrey}>{t('reports-page.key-responsib.first-aider')}</HeadlineSmall>
        <TextField onChange={onFirstAiderChange}
                   value={`${firstAiderValue}`}
                   disabled={isDisabled}
                   leftText={'reports-page.key-responsib.one-first-aider'}
                   onBlur={onSaveFirstAider}
                   rightText={'reports-page.key-responsib.staff'} />
      </ContentCard>
    </Container>
  )
}

interface Props {
}


const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin-top: 32px;
  @media (${tablet}) {
    .weekFlicker {
      margin-bottom: 0;
    }
  }
`

const ContentCard = styled(FlatContentCard)<any>`
  width: 400px;
  max-width: 100%;
  margin-bottom: 16px;
  border: 1px solid ${Colours.lightGrey};
  .textField__input {
    width: 50px;
  }
  margin-right: 0;
  @media (min-width: 895px) {
    margin-right: 24px;
    &:last-child {
      margin-right: 0;
    }
  }
`

